{
	"brand": {
		"tab_title": "{{productName}} · Backoffice",
		"tab_title_unbranded": "Backoffice"
	},
	"login": {
		"failed": "Accesso non completato. Riprova.",
		"redirecting": "Reindirizzamento all'accesso…",
		"request_id": "Codice richiesta: {{requestId}}",
		"retry": "Riprova"
	}
}
